import { sendStats } from './stats';

export const wideo = () => {
  const newPlayer = (url, i) => new WP.player({
    url,
    target: `player_${i}`,
    adv: false,
    hiderelated: true,
    extendedrelated: false,
    floatingplayer: false,
    autoplay: true,
    forceliteembed: false,
    extendedfullsizeenabled: false,
    asapMobileAutoplay: true
  });

  const playerStats = (
    player,
    playerInitialized,
    statsQuadrantsPos,
    clipName,
    clipMid,
  ) => {
    player.on('INIT', () => {
      if (!playerInitialized) {
        playerInitialized = true;
        // player.setVolume(0.5);
      }
    });
    player.on('START_MOVIE', () => {
      clipName = player.getClipData().title;
      clipMid = player.getClipData().mid;
      sendStats('video', 'view', clipName);
    });
    // player.on('CHANGE_STATE', function () {
    //   //
    // });
    player.on('END_MOVIE', () => {
      sendStats('video', 'end', clipName);
    });
    player.on('UPDATE_POSITION', (e) => {
      const position = player.getPosition();
      statsQuadrants(position);
    });
    var statsQuadrants = function (p) {
      p = Math.round(p * 100);
      if (!statsQuadrantsPos[clipMid]) {
        statsQuadrantsPos[clipMid] = {};
      }
      if (p >= 25 && p < 50) {
        if (!statsQuadrantsPos[clipMid][25]) {
          statsQuadrantsPos[clipMid][25] = 1;
          sendStats('video', 'quarter=25', clipName);
        }
      } else if (p >= 50 && p < 75) {
        if (!statsQuadrantsPos[clipMid][50]) {
          statsQuadrantsPos[clipMid][50] = 1;
          sendStats('video', 'quarter=50', clipName);
        }
      } else if (p >= 75 && p < 100) {
        if (!statsQuadrantsPos[clipMid][75]) {
          statsQuadrantsPos[clipMid][75] = 1;
          sendStats('video', 'quarter=75', clipName);
        }
      }
    };
  };

  const startPLayers = () => {
    document.querySelectorAll('.player').forEach((el, i) => {
      el.setAttribute('id', `player_${i}`);
      const url = el.getAttribute('data-url');
      const playerInitialized = false;
      const statsQuadrantsPos = {};
      let clipName;
      let clipMid;
      let player;
      WP.push(() => {
        player = newPlayer(url, i);
        playerStats(
          player,
          playerInitialized,
          statsQuadrantsPos,
          clipName,
          clipMid,
        );
      });
    });
  };
  if (document.querySelectorAll('.player').length > 0) {
    startPLayers();
  }
};
